import { Component} from '@angular/core';
import { GeneralExerciseComponent } from '../../General/g-exercise.component';
import { ActivatedRoute } from '@angular/router';
import { TopicService } from '../topic.service';
import { NumberCardsService } from '../number-cards.service';
import { Location } from '@angular/common';
import { MessageService } from '../../shared/message.service';

export abstract class SuperExerciseComponent extends GeneralExerciseComponent{

  //typespecifics
  requestedNumber: number;
  protected representation: string;
  cards: number[];
  protected showHelptext: Boolean;
  protected showSymbols: Boolean;

  //solution
  protected count: number[] = [];
  protected solution: number[] = [];

  //feedback
  protected feedback: string = "";
  protected error: number[] = [];

  constructor(protected numberCardsService: NumberCardsService, protected activatedRoute: ActivatedRoute, protected topicService: TopicService, protected messageService: MessageService) {   
    super(activatedRoute, topicService, messageService);
    //initializtion is done in ngOnInit of parent class
  }


  /** set the typespecific information based on the configuration*/
  setTypeSpecificsFromConfiguration() {
    let typespecs = this.configuration["typespecifics"];
    this.representation = typespecs["representation"];
    this.cards = this.numberCardsService.getCards(this.representation, typespecs["representationSpec"]);
    this.showHelptext = typespecs["showHelp"] == "text";
    this.showSymbols = (typespecs["showHelp"] == "symbols" || typespecs["showHelp"] == "text");
  }

  /** set the typespecific information based on the state */
  setTypeSpecificsFromState() {
    let count = this.state.typespecific.count;
    if (count != undefined) {
      let i: number = 0;
      for (let card of this.cards) {
        this.count[card] = count[i];
        i++;
      }
    }
    if(this.state.solved != undefined){
      this.solved = this.state.solved;
    }
  }

  /** computes the typespecific part of the state */
  computeState() {
    this.state.typespecific.count = [];
    for (let card of this.cards) {
      this.state.typespecific.count.push(this.count[card]);
    }
  }



}
